<template>
  <div class="bio-page">
    <h1 class="title">Tous les personnages</h1>

		<div class="bio-page__group">
			<h2 class="subtitle">Les joueurs</h2>

			<div class="bio-page__group-container">
				<div class="bio-page__character" v-for="(character, i) in getCharactersData" data-type="character" @click="openPopinInfos" :data-id="i">
					<img :src="character.img" alt="character.name">
					<p>{{ character.name }}</p>
				</div>
			</div>
		</div>

		<div class="bio-page__group">
			<h2 class="subtitle">Les protagonistes</h2>

			<div class="bio-page__group-container">
				<div class="bio-page__character bio-page__character--all" v-for="(person, i) in getQuestionsData" data-type="person" :data-id="i" @click="openPopinInfos" >
					<img :src="`http://transfertsdepekin.fr/assets/questions/${person.characterImg}`" alt="person.name">
					<p>{{ person.character }}</p>
				</div>
			</div>
		</div>

		<transition name="fadeIn">
      <popin-infos v-if="getShowPopin" :params="popinParams"></popin-infos>
    </transition>
  </div>
</template>

<script>
	import Transition from '~mixins/Transition';
	import selectParent from 'select-parent';
	import PopinInfos from './PopinInfos';

	export default {
		name: 'bio-page',
		components: {
			PopinInfos,
		},
		mixins: [Transition],
		data() {
			return {
				popinParams: null,
			};
		},
		methods: {
			openPopinInfos(e) {
				let parent = selectParent('.bio-page__character', e.target);

				if (!parent) {
					parent = e.target;
				}

				const type = parent.getAttribute('data-type');
				const id = parent.getAttribute('data-id');

				let data;

				if (type === 'character') {
					data = this.getCharactersData[parseInt(id, 10)];
				} else {
					data = this.getQuestionsData[id];
				}

				data.typeInfos = type;

				// this.showPopinInfos = true;
				this.popinParams = data;
				// this.$store.commit('setDataPopin', data);
        this.$store.commit('setShowPopin', true);
			},
		},
		computed: {
			getCharactersData() {
				return this.$store.getters.getCharactersData;
			},
			getQuestionsData() {
				return this.$store.getters.getQuestionsData;
			},
			getShowPopin() {
        return this.$store.getters.getShowPopin;
      },
		},
	};
</script>


<style lang="scss">
	#app.reglement .app-content {
		@include mobile {
			padding-top: 110px;
		}
	}

	.bio-page {
		.title {
			margin: 70px 0 60px;

			@include tablet-to-mobile {
				margin: 120px 0 60px;
			}
		}

		.subtitle {
			display: inline-block;
			text-transform: uppercase;
			margin: 0;
			padding: 10px;
			border: 2px dashed $blue;
			margin-bottom: 60px;
			@include fontSize(30);

			@include mobile {
				@include fontSize(21);				
			}
		}
	}

	.bio-page__group {
		width: 80%;
		margin: auto;
		text-align: center;
		padding-bottom: 100px;
		opacity: 0;
		animation: appearBottom .4s .1s ease-in-out forwards;

		@include mobile {
			width: 100%;
			padding-bottom: 40px;
		}

		.bio-page__group-container {
			display: flex;
			align-items: baseline;
			justify-content: center;
			flex-wrap: wrap;
		}

		.bio-page__character {
			width: calc(100% / 4);
			margin-bottom: 30px;
			cursor: pointer;
			@include defaultTransition(.4);

			&--all {
				width: calc(100% / 5);
			}

			@include mobile {
				width: calc(100% / 2);
			}

			img {
				max-width: 80%;
				display: block;
				margin: auto;

				@include mobile {
					max-width: 100%;
					max-height: 170px;
				}
			}

			p {
				margin-top: 15px;
				color: $blue;
				@include fontSize(15);
			}

			&:hover {
				transform: scale(1.1);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Bio.vue?311b06da